import { render, staticRenderFns } from "./datatable-line.vue?vue&type=template&id=37625252&scoped=true"
import script from "./datatable-line.vue?vue&type=script&lang=js"
export * from "./datatable-line.vue?vue&type=script&lang=js"
import style0 from "./datatable-line.vue?vue&type=style&index=0&id=37625252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37625252",
  null
  
)

export default component.exports